import { AlertCircle } from "lucide-react";
import { BACKEND_MAINTENANCE_MESSAGE } from "../../lib/maintenance-message";

interface ChatErrorBannerProps {
  error: string;
}

export function ChatErrorBanner({ error }: ChatErrorBannerProps) {
  const shouldShowProviderSetup = isProviderAuthLikeError(error);
  const displayError = error.trim() || BACKEND_MAINTENANCE_MESSAGE;

  return (
    <div className="flex w-full min-w-0 items-start gap-2.5 rounded-lg border border-red-500/25 bg-red-500/8 px-4 py-3 animate-fade-slide-in">
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
      <div className="min-w-0 flex-1">
        <p className="max-h-24 overflow-y-auto whitespace-pre-wrap break-words text-xs leading-relaxed text-red-300">
          {displayError}
        </p>
      </div>
      {shouldShowProviderSetup ? (
        <div className="ml-auto flex shrink-0 justify-end">
          <button
            type="button"
            onClick={() =>
              window.dispatchEvent(
                new CustomEvent("fintheon:open-provider-setup"),
              )
            }
            className="rounded border border-[var(--fintheon-accent)]/35 bg-[var(--fintheon-accent)]/12 px-3 py-1.5 text-[11px] font-medium text-[var(--fintheon-accent)] transition-colors hover:bg-[var(--fintheon-accent)]/20 disabled:opacity-60"
          >
            Provider setup
          </button>
        </div>
      ) : null}
    </div>
  );
}

function isProviderAuthLikeError(error: string): boolean {
  const lower = error.toLowerCase();
  const hasProvider =
    /nous|grok|xai|x\.ai|openai|opencode|anthropic|glm|deepseek|provider/.test(
      lower,
    );
  const hasAuth =
    /auth|token|credential|reconnect|reauthorization|expired|invalid|401|403/.test(
      lower,
    );
  return (hasProvider && hasAuth) || lower.includes("model configuration");
}
